import { render, staticRenderFns } from "./CrmTab.html?vue&type=template&id=5b46a7d0&scoped=true&external"
import script from "./CrmTab.js?vue&type=script&lang=js&external"
export * from "./CrmTab.js?vue&type=script&lang=js&external"
import style0 from "./CrmTab.scss?vue&type=style&index=0&id=5b46a7d0&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b46a7d0",
  null
  
)

export default component.exports